/* Generated by restful-react */

import React from 'react'
import { Get, GetProps, useGet, UseGetProps } from 'restful-react'

export const SPEC_VERSION = 'v5'
export interface RequestFilters {
  carrierApplicationId?: number | string
  actionType: string
  includes: string[]
}

export interface BaseUser {
  id: number
  parentUserId: number
  firstName: string
  lastName: string
}

export interface LaneLocation {
  stateCode: string
  countryCode: string
  city?: string
  id: number
}

export interface CarrierApplicationOfferLimits {
  id: string
  uuid: string
  carrierApplicationId: string
  mondayLimit: number
  tuesdayLimit: number
  wednesdayLimit: number
  thursdayLimit: number
  fridayLimit: number
  saturdayLimit: number
  sundayLimit: number
  createdById: string
  createdAt: string
  createdBy: {
    id: string
    firstName: string
    lastName: string
  }
  pickupLocation: {
    stateCode: string
    countryCode: string
    city: string
    radius: number
  }
}

export interface RoutingGuideRowProps {
  createdAt: string
  contractId: number
  uuid: string
  rate: string
  isContract: boolean | null
  approvedById: number | null
  approvedByParentUserId?: number | null
  approvedAt: string | null
  isOnlyBeer: boolean | null
  isOnlyDropTrailer: boolean | null
  isDatMarketApplicable: boolean | null
  startDate: string | null
  expirationDate: string | null
  pickupRadiusMiles: number | null
  deliveryRadiusMiles: number | null
  loadType: 'any' | 'spot' | 'contract'
  rateType?: 'flat' | 'rpm' | null
  creationSource?: string
  shipperApplicationId: number | null
  isShipperExclusive: boolean | null
  deliveryTimePreference: 'any' | 'same-day' | 'next-day'
  deliveryRadiusRangeMin: number | null
  deliveryRadiusRangeMax: number | null
  actionType: string
  pickupTimePreferences: {
    id: number
    carrierContractLaneUuid: string
    dayOfWeek: 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday'
    startTime: string | null
    endTime: string | null
  }[]
  dispatcher: BaseUser & {
    phone: string
    cellPhone: string
  }
  carrier: {
    id: number
    legalName: string
    state: string
  }
  createdBy: BaseUser & {
    isTransfixAdmin: boolean
    fullName: string
  }
  equipment: {
    id: number
    key: string
    name: string
  }
  pickup: LaneLocation
  delivery: LaneLocation
  carrierApplicationOfferLimits?: CarrierApplicationOfferLimits
  shipper?: {
    id: number
    name: string
  }
  carrierManagers?: {
    id: number
    parentUserId: number
    fullName: string
    phone: string
    email: string
    userType: string
    role: string
  }[]
  approvedBy?: BaseUser
}

export interface ReservedLanes {
  carriercontractlanes: RoutingGuideRowProps[]
  nextPage: boolean
}

export interface GetCarrierReservedLanesQueryParams {
  /**
   * filter options
   */
  filters: RequestFilters
  /**
   * Page number of request
   */
  pageCount?: number
}

export type GetCarrierReservedLanesProps = Omit<
  GetProps<ReservedLanes, void, GetCarrierReservedLanesQueryParams, void>,
  'path'
>

/**
 * Get carrier reserved lanes details
 */
export const GetCarrierReservedLanes = (props: GetCarrierReservedLanesProps) => (
  <Get<ReservedLanes, void, GetCarrierReservedLanesQueryParams, void>
    path='/v5/carrier_contract_lanes'
    {...props}
  />
)

export type UseGetCarrierReservedLanesProps = Omit<
  UseGetProps<ReservedLanes, void, GetCarrierReservedLanesQueryParams, void>,
  'path'
>

/**
 * Get carrier reserved lanes details
 */
export const useGetCarrierReservedLanes = (props: UseGetCarrierReservedLanesProps) =>
  useGet<ReservedLanes, void, GetCarrierReservedLanesQueryParams, void>(
    `/v5/carrier_contract_lanes`,
    props
  )
